document.addEventListener('DOMContentLoaded', () => {
  console.log('✅ USWE v2 image swatch script loaded');

  // --- Get product data ---
  const productJsonEl = document.querySelector('#ProductJson');
  if (!productJsonEl) {
    console.warn('⚠️ Product JSON not found');
    return;
  }

  const productData = JSON.parse(productJsonEl.textContent);
  console.log('🧩 productData loaded', productData);

  // --- Detect main variant option ("Color" or fallback) ---
  let mainOptionName = 'Color';
  let optionIndex = productData.options.findIndex(opt => opt.toLowerCase() === 'color');
  let optionInputsSelector = `input[name^="options[${mainOptionName}]"]`;
  let optionInputs = document.querySelectorAll(optionInputsSelector);
  console.log(`🎨 Found "${mainOptionName}" inputs:`, optionInputs.length);

  // ✅ Fallback if Color not found or only one option
  const fallbackOptions = ['opening', 'closure', 'harness'];
  if (optionInputs.length <= 1 || optionIndex === -1) {
    for (const alt of fallbackOptions) {
      const idx = productData.options.findIndex(opt => opt.toLowerCase() === alt);
      if (idx !== -1) {
        mainOptionName = alt.charAt(0).toUpperCase() + alt.slice(1);
        optionIndex = idx;
        optionInputsSelector = `input[name^="options[${mainOptionName}]"]`;
        optionInputs = document.querySelectorAll(optionInputsSelector);
        console.log(`🪟 Using "${mainOptionName}" instead, found:`, optionInputs.length);
        break;
      }
    }

    if (optionIndex === -1) {
      console.log('🟢 Only one option type found — showing all images.');
      document.querySelectorAll('.product__slide, .product__thumb').forEach(el => (el.style.display = ''));
      return;
    }
  }

  // --- Build image mapping ---
  const optionImageRanges = {};
  productData.variants.forEach(variant => {
    if (variant.featured_media) {
      const value = variant[`option${optionIndex + 1}`];
      optionImageRanges[value] = variant.featured_media.position;
    }
  });

  const sortedValues = Object.keys(optionImageRanges).sort(
    (a, b) => optionImageRanges[a] - optionImageRanges[b]
  );

  const optionImageGroups = {};
  sortedValues.forEach((value, i) => {
    const start = optionImageRanges[value];
    const end =
      i < sortedValues.length - 1
        ? optionImageRanges[sortedValues[i + 1]] - 1
        : productData.media.length;
    optionImageGroups[value] = { start, end };
  });

  console.log(`📊 ${mainOptionName} image groups`, optionImageGroups);

  // --- Update gallery ---
  function updateImages(selectedValue) {
    const group = optionImageGroups[selectedValue];
    if (!group) {
      console.warn(`⚠️ No image group found for ${mainOptionName}:`, selectedValue);
      return;
    }

    const slides = document.querySelectorAll('.product__slide');
    const thumbs = document.querySelectorAll('.product__thumb');

    slides.forEach((el, index) => {
      const pos = index + 1;
      el.style.display = pos >= group.start && pos <= group.end ? '' : 'none';
    });

    thumbs.forEach((el, index) => {
      const pos = index + 1;
      el.style.display = pos >= group.start && pos <= group.end ? '' : 'none';
    });
  }

  // --- (1) USWE color swatch clicks ---
  const swatches = document.querySelectorAll('.uswe-color-swatch');
  swatches.forEach(swatch => {
    swatch.addEventListener('click', e => {
      e.preventDefault();
      const value = swatch.dataset.value;
      const normalized = value.trim().toLowerCase();

      const inputs = Array.from(document.querySelectorAll('input[data-single-option-selector]'));
      const match = inputs.find(el => el.value.toLowerCase() === normalized);

      if (match) {
        match.checked = true;
        match.dispatchEvent(new Event('change', { bubbles: true }));
      }

      document.querySelectorAll('.uswe-color-swatch.active').forEach(el => el.classList.remove('active'));
      swatch.classList.add('active');
      updateImages(value);
    });
  });

  // --- (2) Native Shopify buttons (for non-color options) ---
  optionInputs.forEach(input => {
    input.addEventListener('change', () => {
      console.log(`🧭 Changed ${mainOptionName} to`, input.value);
      updateImages(input.value);
    });
  });

  // --- Auto-select initial variant ---
  function selectInitialVariant() {
    const checked = document.querySelector('input[data-single-option-selector]:checked');
    if (checked) {
      const initialValue = checked.value.trim();
      updateImages(initialValue);

      const activeSwatch = [...document.querySelectorAll('.uswe-color-swatch')]
        .find(el => el.dataset.value.trim().toLowerCase() === initialValue.toLowerCase());
      if (activeSwatch) activeSwatch.classList.add('active');
      return true;
    }

    const firstAvail = productData.variants.find(v => v.available) || productData.variants[0];
    if (!firstAvail) return false;

    const initialValue = firstAvail[`option${optionIndex + 1}`];
    if (!initialValue) return false;

    const inputs = [...document.querySelectorAll('input[data-single-option-selector]')];
    const match = inputs.find(el => el.value.trim().toLowerCase() === initialValue.toLowerCase());
    if (match) {
      match.checked = true;
      match.dispatchEvent(new Event('change', { bubbles: true }));
      updateImages(initialValue);

      const activeSwatch = [...document.querySelectorAll('.uswe-color-swatch')]
        .find(el => el.dataset.value.trim().toLowerCase() === initialValue.toLowerCase());
      if (activeSwatch) activeSwatch.classList.add('active');
      return true;
    }

    const swatch = [...document.querySelectorAll('.uswe-color-swatch')][0];
    if (swatch) {
      swatch.click();
      return true;
    }

    return false;
  }

  // --- Run once gallery is ready ---
  const productComponent = document.querySelector('product-component');
  if (productComponent) {
    const observer = new MutationObserver(() => {
      const slides = document.querySelectorAll('.product__slide');
      if (slides.length && selectInitialVariant()) observer.disconnect();
    });
    observer.observe(productComponent, { childList: true, subtree: true });
  } else {
    if (!selectInitialVariant()) {
      const observer = new MutationObserver(() => {
        if (selectInitialVariant()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }
});